import * as React from 'react';
import { TContacts } from './Contacts.types';
import { BreadcrumbsBlock } from 'components';
import { useLocalize } from 'store/contexts/LocalizationContext/LocalizationContext.provider';
import './Contacts.styled.scss';

export const Contacts: TContacts = () => {
  const localize = useLocalize();

  return (
    <section className="contacts-page">
      <div className="contacts-page__container">
        <div className="contacts-page__content">
          <BreadcrumbsBlock />
          <div className="contacts-page__surface">
            <h3 className="contacts-page__title">
              {localize('contacts.page.title')}
            </h3>
            <p className="contacts-page__subtitle body2">
              {localize('contacts.page.subtitle')}
            </p>
            <div className="contacts-page__list">
              <p className="contacts-page__row body1">
                {localize('contacts.page.address')}
              </p>
              <p className="contacts-page__row body1">
                {localize('contacts.page.email.label')}{' '}
                <a href="mailto:support@customgifts.pl">
                  support@customgifts.pl
                </a>
              </p>
              <p className="contacts-page__row body1">
                {localize('contacts.page.phone')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
